import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Button from "@ats/src/components/shared/Button";

function MessageMailMergeMenuBar({
  viewRef,
  menu,
  state,
  dispatch,
  allowSenderMailMergeFields = true,
  disabled = false,
}) {
  // console.log("%c[MessageMailMergeMenuBar][ProseMirror] render", "color: #1976D2", {
  //   menu,
  //   state,
  //   dispatch,
  //   view: viewRef.current?.view,
  // });

  const handleInsert = (text) => {
    return (state, dispatch) => {
      let { from, to } = state.selection;
      // index = $from.index();

      console.log("%c[MessageMailMergeMenuBar] handleInsert", "color: #1976D2", {
        selection: state.selection,
      });
      // if (!$from.parent.canReplaceWith(index, index, dinoType)) return false;
      if (dispatch) dispatch(state.tr.insertText(text, from, to));
      return true;
    };
  };

  return (
    <Styled.VariableButtons>
      <Button
        styleType="secondary"
        data-testid="candidate-first-name"
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsert("{{CandidateFirstName}}")(state, dispatch);
        }}
        disabled={disabled}
      >
        <span>Candidate first name</span>
      </Button>
      <Button
        styleType="secondary"
        data-testid="candidate-last-name"
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsert("{{CandidateLastName}}")(state, dispatch);
        }}
        disabled={disabled}
      >
        <span>Candidate last name</span>
      </Button>
      <Button
        styleType="secondary"
        data-testid="candidate-full-name"
        // onClick={() => handleInsert("{{CandidateFullName}}")}
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsert("{{CandidateFullName}}")(state, dispatch);
        }}
        disabled={disabled}
      >
        <span>Candidate full name</span>
      </Button>
      <Button
        styleType="secondary"
        data-testid="job-title"
        // onClick={() => handleInsert("{{JobTitle}}")}
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsert("{{JobTitle}}")(state, dispatch);
        }}
        disabled={disabled}
      >
        <span>Job title</span>
      </Button>
      {allowSenderMailMergeFields && (
        <>
          <Button
            styleType="secondary"
            data-testid="sender-first-name"
            // onClick={() => handleInsert("{{SenderFirstName}}")}
            onMouseDown={(event) => {
              event.preventDefault();
              handleInsert("{{SenderFirstName}}")(state, dispatch);
            }}
            disabled={disabled}
          >
            <span>Sender first name</span>
          </Button>
          <Button
            styleType="secondary"
            data-testid="sender-full-name"
            // onClick={() => handleInsert("{{SenderFullName}}")}
            onMouseDown={(event) => {
              event.preventDefault();
              handleInsert("{{SenderFullName}}")(state, dispatch);
            }}
            disabled={disabled}
          >
            <span>Sender full name</span>
          </Button>
        </>
      )}
      <Button
        styleType="secondary"
        data-testid="organization-name"
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsert("{{OrganizationName}}")(state, dispatch);
        }}
        disabled={disabled}
      >
        <span>Organization name</span>
      </Button>
    </Styled.VariableButtons>
  );
}

export default MessageMailMergeMenuBar;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.VariableButtons = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: MessageMailMergeMenuBar_VariableButtons;
    ${[t.mt(1)]}
    transition: box-shadow 0.2s ease;
    display: flex;
    flex-wrap: wrap;
    button {
      ${[t.h(8), t.px(2), t.text.xs, t.mr(1), t.mt(1)]}

      ${t.mq["md"]} {
        ${t.h(6)}
      }
    }
  `;
});
